import axios from 'axios'
import {baseURL} from '@/services/baseURL.js'
import Store from '@/store';

const apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    accept: 'application/json',
    'content-type': 'application/json',
  },
  withCredentials: false,
})

apiClient.interceptors.request.use(function(config) {
  const token = Store.state.Pengguna.ev_id;
    //const token ='okennd72q65sjavna61n5qq6i7';
    if(token) {
        config.headers.Authorization = `${token}`;
        console.log('request intercepted, token set to headersadsadsadsa')
    }else{
      console.log('token not set',token)
    }
    console.log('axios config in interceptor',config)
    return config;
  }, function(err) {
    return Promise.reject(err);
  });
  
  const perananLabel=[]
  perananLabel[1]='Pengguna Asas'
  perananLabel[2]='Pentadbir Sistem'
  perananLabel[3]='Helpdesk'



export default {
    getElemen(search) {
    return apiClient.get('/selenggara/get_elemen.php', { params: search })
  },
  getMaklPenjawatAwamServ(search){
    return apiClient.get('/salary_gaji/get_rekodPeribadi.php', { params: search })
  },

  setTambahMaklPer(formPer){
    return apiClient.post('/pemanggil/simpan_aduan.php',formPer)
  },

  getButiranTahunInfoParam(Search) {
    return apiClient.get('/salary_gaji/get_butiran_tahun_info.php',{params:Search})
  },

  getButiranTahunInfoParam(Search) {
    return apiClient.get('/salary_gaji/get_butiran_tahun_info.php',{params:Search})
  },
  getButiranTahunDataParam(Search) {
    return apiClient.get('/salary_gaji/get_butiran_tahun_data.php',{params:Search})
  },
  getMaklPenjawatAwam(Search) {
    return apiClient.get('/salary_gaji/get_MaklPenjawatawam.php',{params:Search})
  },
  get_MaklLaporanSelesai(Search) {
    return apiClient.get('/salary_gaji/get_MaklLaporanSelesai.php',{params:Search})
  },
  getLatestTahun(Search) {
    return apiClient.get('/salary_gaji/get_tahunLatest.php',{params:Search})
  },
  ValElemen(Search) {
    return apiClient.get('/salary_gaji/Val_Elemen.php',{params:Search})
  },
  getDashboard() {
    return apiClient.get('/salary_gaji/get_dashboardKiraan.php')
  },
  getSenaraiPenjawatAwamInfo(Search) {
    return apiClient.get('/salary_gaji/get_PADlmTindakan_info.php',{params:Search})
  },
  getSenaraiPenjawatAwamdata(Search) {
    return apiClient.get('/salary_gaji/get_PADlmTindakan_data.php',{params:Search})
  },
  getSenaraiPenjawatAwamSelesaiInfo(Search) {
    return apiClient.get('/salary_gaji/get_Selesai_info.php',{params:Search})
  },
  getSenaraiPenjawatAwamSelesaidata(Search) {
    return apiClient.get('/salary_gaji/get_Selesai_data.php',{params:Search})
  },
  getStatusNOKp(Search){
    return apiClient.get('/salary_gaji/get_statusICNo.php',{params:Search})
  },
  setMaklPenjawatAwam(formPenjawatAwam){
    return apiClient.post('/salary_gaji/simpan_MaklPenjawatAwam.php',formPenjawatAwam)
  },
  setElemen(form){
    return apiClient.post('/salary_gaji/simpan_Elemen.php',form)
  },
  setElemenPGT(form){
    return apiClient.post('/salary_gaji/simpan_ElemenPGT.php',form)
  },
  setElemen7(form){
    return apiClient.post('/salary_gaji/simpan_elemen2007.php',form)
  },
  setElemen8(form){
    return apiClient.post('/salary_gaji/simpan_elemen2012.php',form)
  },
  setElemen181911(form){
    return apiClient.post('/salary_gaji/simpan_Elemen181911.php',form)
  },
  setElemenAnjakan(form){
    return apiClient.post('/salary_gaji/simpan_elemenAnjakan.php',form)
  },
  setElemen9(form){
    return apiClient.post('/salary_gaji/simpan_elemen2013.php',form)
  },
  setElemen2016(form){
    return apiClient.post('/salary_gaji/simpan_elemen2016.php',form)
  },
  setElemenTukarLantik(form){
    return apiClient.post('/salary_gaji/simpan_ElemenTkrLantik.php',form)
  },
  getRowBef(Search) {
    return apiClient.get('/salary_gaji/get_dataRowBef.php',{params:Search})
  },
  setElemenNaikPangkat(form){
    return apiClient.post('/salary_gaji/simpan_ElemenNaikPangkat.php',form)
  },
  setElemenKUPLulus(form){
    return apiClient.post('/salary_gaji/simpan_elemenKUPLulus.php',form)
  },
  setElemenKGTKhas(form){
    return apiClient.post('/salary_gaji/simpan_elemenKGTKhas.php',form)
  },
  setElemenCalcBGE(form){
    return apiClient.post('/salary_gaji/simpan_elemenBGE.php',form)
  },
  simpan_elemenSSPAF1(form){
    return apiClient.post('/salary_gaji/simpan_elemenSSPAF1.php',form)
  },
  simpan_elemenSSPAF2(form){
    return apiClient.post('/salary_gaji/simpan_elemenSSPAF2.php',form)
  },
  simpan_elemenKUPSSPAF2(form){
    return apiClient.post('/salary_gaji/simpan_elemenCalSSPA.php',form)
  },
  delRowTahun(form){
    return apiClient.post('/salary_gaji/delRow.php',form)
  },
  EditRowTahun(form){
    return apiClient.post('/salary_gaji/edit.php',form)
  },
  updRow(form){
    return apiClient.post('/salary_gaji/updRow.php',form)
  },
  delRowPenjawatAwam(form){
    return apiClient.post('/salary_gaji/delRow_pejawatAwam.php',form)
  }
}
